export const supported = (
	typeof navigator.getGamepads === 'function'
);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/support.ts